var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-slot",class:{ empty: _vm.cards.length <= 0 }},_vm._l((_vm.cards),function(card){return _c('div',{staticClass:"card"},[_c('div',{staticClass:"overlay",style:({ opacity: _vm.overlay })}),_c('img',{attrs:{"src":card}})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-610020be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/card.vue
// module id = null
// module chunks = 